import { DependencyList, useEffect } from 'react';
import { useSetRecoilState } from 'recoil';
import { errorState } from '../state/error';

/**
 * Creates an effect with a promise callback
 */
export const useAsyncEffect = (callback: () => Promise<void>, deps: DependencyList) => {
  const setError = useSetRecoilState(errorState);
  useEffect(() => {
    callback().catch(e => {
      setError(e);
      throw e;
    });
  }, deps);
};
